<div class="pwd-recovery-container">
  <div class="pwd-recovery-container-body">
    <form [formGroup]="pwdRecoveryForm">
      <cowing-input [type]="'password'" [iconShow]="true" [iconName]="'lock'" [isForm]="true" [fixedIcon]="true"
        [placeholder]="'pwd-recovery.new-password' | translate" [control]="pwdRecoveryForm.get('newPassword')">
      </cowing-input>
      <cowing-input [type]="'password'" [iconShow]="true" [iconName]="'lock'" [isForm]="true" [fixedIcon]="true"
        [placeholder]="'pwd-recovery.repeat-new-password' | translate"
        [control]="pwdRecoveryForm.get('repeatNewPassword')">
      </cowing-input>
    </form>
  </div>
  <div class="pwd-recovery-container-button">
    <cowing-button [label]="'pwd-recovery.continue' | translate" (event)="changePwd($event)"
      [disabled]="!pwdRecoveryForm.valid">
    </cowing-button>
    <p class="error-message" *ngIf="error !== ''">{{ error }}</p>
  </div>
</div>